/* eslint-disable no-unused-vars */

import { siteMapActions } from '@redux/slices/site-map';
import { getAppDispatch } from '@utilities/dispatch.util';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

export default function PrivateRoute({ children, roles = [] }) {
  let authenticated = true;
  const user = useSelector((state) => state.auth.user);
  const { showMapView = false } = useSelector((state) => state.siteMap) || {};

  const dispatch = getAppDispatch();

  const location = useLocation();

  if (!user) authenticated = false;
  if (roles.length > 0 && !roles.includes(user.role)) authenticated = false;

  useEffect(() => {
    if (location.pathname !== 'sites' && showMapView) {
      dispatch?.(siteMapActions.setShowMapView(false));
    }
  }, [location.pathname]);

  return (
    <>
      {authenticated ? (
        children
      ) : (
        <Navigate to={`/${location.pathname ? `?redirectURL=${location.pathname}` : ''}`} />
      )}
    </>
  );
}
